// v0.50 — wallet codes (client mirror of worker/src/codes.ts).
//
// A wallet's public identity is a short alphanumeric code (e.g. "7A82-ER7Q"),
// replacing the v0.11 adjective-noun names. The client never GENERATES a code
// (the worker's /name/propose does, so the passkey label + stored slug agree);
// it only canonicalises, validates and formats — for pay-link parsing, boot
// routing, the To field, and display. Kept in step with the worker module: same
// alphabet, same length, same canonical/display forms.

export const CODE_ALPHABET = "23456789ABCDEFGHJKMNPQRSTVWXYZ"; // 30 symbols
export const WALLET_CODE_LEN = 8;

/** Canonicalise any user/URL input: uppercase, drop anything not in the alphabet. */
export function canonicalizeCode(input: string): string {
  return (input || "")
    .toUpperCase()
    .split("")
    .filter((ch) => CODE_ALPHABET.includes(ch))
    .join("");
}

/** Is this a valid wallet code once canonicalised (exactly WALLET_CODE_LEN chars)? */
export function isWalletCode(s: string): boolean {
  return canonicalizeCode(s).length === WALLET_CODE_LEN;
}

/** Group a canonical code into the display form "XXXX-XXXX". */
export function formatCode(canonical: string): string {
  const c = canonicalizeCode(canonical);
  if (c.length <= 4) return c;
  const half = Math.ceil(c.length / 2);
  return `${c.slice(0, half)}-${c.slice(half)}`;
}
